"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _ReportWrapper = _interopRequireDefault(require("../ReportWrapper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AppDefs = window.cccisd.appDefs;
var ClientReports = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function ClientReports() {
    _classCallCheck(this, ClientReports);
    return _callSuper(this, ClientReports, arguments);
  }
  _inherits(ClientReports, _React$Component);
  return _createClass(ClientReports, [{
    key: "render",
    value: function render() {
      var content = '';
      if (this.props.isLoading) {
        content = this.props.loadingNode !== null ? this.props.loadingNode : /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
          loading: this.props.isLoading
        });
      } else if (this.props.isClientListEmpty) {
        content = /*#__PURE__*/_react["default"].createElement("div", null, this.props.clientListEmptyMessage);
      } else {
        content = /*#__PURE__*/_react["default"].createElement(_ReportWrapper["default"], {
          name: "clientReports",
          reportJson: AppDefs.reports,
          selectedEntity: this.props.selectedEntity,
          selectedEntityNexusClass: this.props.selectedEntityNexusClass,
          selectedEntityType: this.props.selectedEntityType,
          selectedEntityTypeLabel: this.props.selectedEntityTypeLabel,
          selectedEntityTextFieldPath: this.props.selectedEntityTextFieldPath,
          reportType: "client",
          tabWidths: this.props.tabWidths
        });
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "appdefs-data-entry ".concat(this.props.className)
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h1", null, this.props.pageTitle), /*#__PURE__*/_react["default"].createElement("p", null, this.props.pageDescription)), /*#__PURE__*/_react["default"].createElement("div", null, content));
    }
  }]);
}(_react["default"].Component);
_defineProperty(ClientReports, "propTypes", {
  pageTitle: _propTypes["default"].string,
  pageDescription: _propTypes["default"].string,
  isLoading: _propTypes["default"].bool,
  loadingNode: _propTypes["default"].node,
  clientListEmptyMessage: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  isClientListEmpty: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  selectedEntity: _propTypes["default"].object,
  selectedEntityNexusClass: _propTypes["default"].string,
  selectedEntityType: _propTypes["default"].string,
  selectedEntityTypeLabel: _propTypes["default"].string,
  selectedEntityTextFieldPath: _propTypes["default"].string,
  tabWidths: _propTypes["default"].object
});
_defineProperty(ClientReports, "defaultProps", {
  pageTitle: 'Client Reports',
  pageDescription: '',
  loadingNode: null,
  tabWidths: {
    left: 3,
    right: 9
  }
});